import { Component, OnInit, Input, Output, ChangeDetectorRef, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';

export interface ActionMenu {
    heading: string | Observable<string>;
    options: ActionMenuOption[];
}

export interface ActionMenuOption {
    label: string | Observable<string>;
    icon?: string;
    eventEmitterTag: string;
}

export interface TableData {
    visibility: string;
    number: string;
    category: string;
    subject: string;
    status: string;
    dateModified: string;
}

@Component({
    selector: 'app-bciti-table',
    templateUrl: './bciti-table.component.html',
    styleUrls: ['./bciti-table.component.scss'],
})
export class BcitiTableComponent implements OnInit {
    constructor(private cdr: ChangeDetectorRef) {}

    @Input() tableData: TableData;
    @Input() columnHeader: any = {};
    @Input() actionMenuData: ActionMenu;
    @Input() htmlProperties: string[] = [];

    @Input() length: number;
    @Input() pageIndex: number;
    @Input() pageSize: number;

    @Output() page = new EventEmitter();

    @Output() actions = new EventEmitter();

    public objectKeys = Object.keys;

    ngOnInit() {
        if (!this.pageSize) {
            this.pageSize = 10;
        }
        if (!this.pageIndex) {
            this.pageIndex = 0;
        }
        if (!this.length) {
            this.length = 0;
        }
    }

    handleClick(tag, element) {
        this.actions.emit({ tag, element });
    }

    addActionsColumn(columns: string[]) {
        const newColumns = columns;
        newColumns.push('actions');
        return newColumns;
    }

    pageChange($event: any) {
        this.page.emit($event);
    }
}
